import Vue from 'vue'
import _ from 'lodash'
import { TreeMirror } from './tree-mirror.js'

var Cobrowsing = (function () {
  function Cobrowsing () {
    this.mirror = null
    this.mirrorClient = null
    this.oDOM = null
    this.base = ''
    this.vue = new Vue()
    this.iframeCibleCobrowsing = null
    this.clientScroll = false
    this.scrollPos = 0
    this.arrayInput = [] // stocke les id des 'input'
  }

  // recupere le contenu d'une iframe dans le DOM
  Cobrowsing.prototype.getIframeContent = function (DomElm) {
    var iframe = DomElm
    var iframeDocument = iframe.contentDocument || iframe.contentWindow.document
    return iframeDocument
  }

  // recadrage la fenetre de cobrowsing par le client
  Cobrowsing.prototype.ResizePreview = function (width, height, DomElm) {
    DomElm.width = width + 'px'
    DomElm.height = height + 'px'
  }

  // calcul la position de la souris client
  Cobrowsing.prototype.MoveMouse = function (x, y, DomElm) {
    DomElm.style.left = x + 'px'
    DomElm.style.top = y + 'px'
  }

  // calcul la position du click souris client
  Cobrowsing.prototype.ClickMouse = function (x, y, DomElm) {
    var ClickPointer = DomElm
    ClickPointer.style.left = x + 'px'
    ClickPointer.style.top = y + 'px'
    ClickPointer.classList.toggle('click')
    setTimeout(function () {
      ClickPointer.classList.toggle('click')
    }, 1000)
  }

  // Fonctions COBROWSING
  // lance une session cobrowsing
  Cobrowsing.prototype.demandeCobrowsing = function (data) {
    console.log('DemandeCobrowsing', data)
    new Vue().$socket.emit('DemandeCobrowsing', {
      demandeActive: data.active,
      datasAgent: data.datasAgent,
      agentSocketID: data.agentSocketID,
      cibleSocketID: data.datasVisiteur.socketID,
      placePupitre: data.placePupitre
    })
  }

  // lance une session cobrowsing
  Cobrowsing.prototype.startSession = function (
    agentSocket,
    infoAgent,
    infoVisiteur,
    isCobrowsing
  ) {
    new Vue().$socket.emit('CreateSession', {
      chatSession: infoVisiteur.visiteurID
    })
    new Vue().$socket.emit('StartCobrowsing', {
      roomName: infoVisiteur.roomName,
      agentID: infoAgent.id,
      chatSession: infoVisiteur.visiteurID,
      agentSocketID: agentSocket,
      clientSocketID: infoVisiteur.socketID,
      status: 'add',
      cobrowsing: isCobrowsing
    })
  }

  // Session avec le client started
  Cobrowsing.prototype.SessionStarted = function (DomElm) {
    var _this = this
    this.scrollPos = 0 // le scrolle est à nouveau initialisé à zéro
    this.iframeCibleCobrowsing = this.getIframeContent(DomElm) // contenu de l'iframe cobrowsing

    // efface le contenu de l'iframe cobrowsing
    while (this.iframeCibleCobrowsing.firstChild) {
      this.iframeCibleCobrowsing.removeChild(
        this.iframeCibleCobrowsing.firstChild
      )
    }
    console.log(
      'start session --> iframeCibleCobrowsing',
      this.iframeCibleCobrowsing
    )

    // demarrage du mirroring
    this.mirror = new TreeMirror(this.iframeCibleCobrowsing, {
      createElement: function (tagName) {
        var node
        if (tagName === 'SCRIPT') {
          node = _this.iframeCibleCobrowsing.createElement('NO-SCRIPT')
          node.style.display = 'none'
          if (typeof node !== 'string') {
            if (typeof node === 'object') {
            }
          }
          return node
        }

        if (tagName === 'HEAD') {
          node = _this.iframeCibleCobrowsing.createElement('HEAD')
          node.appendChild(_this.iframeCibleCobrowsing.createElement('BASE'))
          node.firstChild.href = _this.base
          return node
        }
      }
    })
  }

  // Changement dans le DOM du client
  Cobrowsing.prototype.mirrorChange = function (
    dataJson,
    visiteurInfos,
    DomElm
  ) {
    var data = dataJson.data.change
    // console.log('data', data)
    if (data) {
      if (data.base) {
        this.base = data.base
      }
      if (data.height) {
        this.ResizePreview(data.width, data.height, DomElm)
      }
      if (data.args) {
        try {
          this.mirror[data.f].apply(this.mirror, data.args)
        } catch (err) {
          // il faut afficher une dialogBox pour indique qu'il y a un probleme de chargement
          // et inviter l'agent à recharger le mirroring avec un bouton 'rechager'
          console.log('erreur mirroring', err)
        }
        if (data.f === 'applyChanged') {
          // recharche quel element est modifié
          // console.log('data.args', data.args)
          data.args[2].forEach((dataElement, key) => {
            // console.log('dataElement', dataElement.id)
            // regarde dans le tableau des input si c'est un input qu'il ne faut pas afficher
            let index = this.arrayInput.findIndex(i => i === dataElement.id)
            if (index !== -1) {
              // remplace le contenu de l'input pour cacher les informations
              let char = '*'
              let newText = ''
              // console.log('length 1', dataElement.attributes.value.length)
              // compte le nombre de lettres recus pour afficher le bon nombre de '*'
              for (var i = 0; i < dataElement.attributes.value.length; ++i) {
                newText = newText + char
              }
              this.mirror.idMap[dataElement.id].value = newText
            } else {
              // si c'est un autre formulaire oin affiche le contenu
              if (dataElement.attributes.value) {
                this.mirror.idMap[dataElement.id].value = dataElement.attributes.value
              }
            }
          })
        }
        if (data.f === 'initialize') {
          // console.log(data.f)
          new Vue().$socket.emit('DOMLoaded', { room: dataJson.chatSession })
          console.log(
            'DOMLoaded --> iframeCibleCobrowsing',
            this.iframeCibleCobrowsing
          )
          if (this.iframeCibleCobrowsing.getElementById('AdminPointer')) {
            this.iframeCibleCobrowsing.getElementById('AdminPointer').classList.add('inactifForCobrowsing')
            // let pointer = this.iframeCibleCobrowsing.getElementById('AdminPointer')
            // console.log('adminPointer', pointer)
          }

          // surclass un style pour utiliser le scrollTop
          this.iframeCibleCobrowsing.getElementsByTagName('html')[0].style.overflowX = 'inherit'
        }
      }
      if (data.scroll) {
        // console.log('data.scroll', data.scroll)
        this.clientScroll = true
        this.scrollPos = data.scroll
        if (DomElm) {
          this.getIframeContent(DomElm).body.scrollTo(0, data.scroll) // c'est pour tester avec targetfirst.com
        } else {
          document.getElementById('ClientView_' + visiteurInfos.placePupitre).contentDocument.body.scrollTo(0, data.scroll)
        }
      }
    }
  }

  // Ferme le cobrowsing
  Cobrowsing.prototype.fermeCobrowsing = function (data) {
    console.log('fermeCobrowsing', data)
    new Vue().$socket.emit('StopCobrowsing', {
      roomName: data.datasAgent.entKey,
      agentID: data.datasAgent.id,
      chatSession: data.datasVisiteur.visiteurID,
      agentSocketID: data.agentSocketID,
      clientSocketID: data.datasVisiteur.socketID,
      status: 'remove'
    })
  }

  // chargement du DOM
  Cobrowsing.prototype.DOMLoadedOk = function (dataJson, visiteurInfos) {
    if (visiteurInfos.visiteurID === dataJson.chatSession) {
    }
    console.log('mirror ', this.mirror)
    _.forEach(this.mirror.idMap, (dataElement, key) => {
      // essais de detecter si c'est un formulaire de carte banquaire
      // pour masquer les champs
      if (dataElement && dataElement.nodeName === 'INPUT' && (dataElement.type === 'number' || dataElement.type === 'tel')) {
        // si la taille mini ou max correspond à un champs de cb
        if (dataElement.required === 'required' || dataElement.maxLength === 3 || dataElement.maxLength === 4 || dataElement.maxLength === 15 || dataElement.maxLength === 16 || dataElement.maxLength === 17 || dataElement.maxLength === 18 || dataElement.maxLength === 19 || dataElement.maxLength === 20) {
          // ca resemble à du formulaire de cb
          // masque le champs a risque
          if (dataElement.value.length) {
            let char = '*'
            let newText = ''
              // console.log('length', this.mirror.idMap[dataElement.id].value.length)
            for (var i = 0; i < dataElement.value.length; ++i) {
              newText = newText + char
            }
            dataElement.value = newText
          }
          // push l'id de l'input identifier comme formulaire de paiment
          this.arrayInput.push(parseInt(key))
        }
      }
    })
    // let index = _.findIndex(this.mirror.idMap, {'tagName': 'INPUT'})
    // if (index !== -1) {
    //   console.log('dataElement', index)
    // }
  }

  // position de la souris du visiteur sur ca page
  Cobrowsing.prototype.ClientMousePos = function (
    dataJson,
    visiteurInfos,
    pointer,
    datasIframeCobrowsing,
    DomElm
  ) {
    // console.log('this.scrollPos', this.scrollPos)
    var data = dataJson.data
    if (DomElm) {
      let rect = DomElm.getBoundingClientRect()
      let yOffsetDomElm = rect.top
      let xOffsetDomElm = rect.left
      if (visiteurInfos.visiteurID === dataJson.data.session) {
        this.MoveMouse(
          Math.floor(data.PositionLeft * datasIframeCobrowsing.ratio + xOffsetDomElm),
          Math.floor(data.PositionTop * datasIframeCobrowsing.ratio + yOffsetDomElm - this.scrollPos * datasIframeCobrowsing.ratio),
          pointer
        )
      }
    }
  }

  // Click souris du visiteur sur ca page
  Cobrowsing.prototype.ClientMouseClick = function (
    dataJson,
    visiteurInfos,
    pointer,
    datasIframeCobrowsing,
    DomElm
  ) {
    var data = dataJson.data
    // calcul la diference en la position du pointer et la cadra cobrowsing
    let rect = DomElm.getBoundingClientRect()
    let yOffsetDomElm = rect.top
    let xOffsetDomElm = rect.left
    if (visiteurInfos.visiteurID === data.session) {
      this.ClickMouse(
        Math.floor(data.PositionLeft * datasIframeCobrowsing.ratio + xOffsetDomElm),
        Math.floor(data.PositionTop * datasIframeCobrowsing.ratio + yOffsetDomElm - this.scrollPos * datasIframeCobrowsing.ratio),
        pointer
      )
    }
  }

  // Visiteur scroll la page
  Cobrowsing.prototype.clientScrollView = function (data, theCallback) {
    theCallback({ clientScroll: this.clientScroll })
  }

  // envois les evenements de l'agent au visiteur
  Cobrowsing.prototype.AgentEvent = function (data) {
    // mise à jour de la variable 'this.scrollPos'
    if (data.typeEvent === 'scrollPage') {
      this.scrollPos = data.dataEvent.scrollTop
    }
    // console.log('AgentEvent', data)
    this.clientScroll = false
    new Vue().$socket.emit('AgentEvent', {
      typeEvent: data.typeEvent,
      room: data.datasVisiteur.visiteurID,
      dataEvent: data.dataEvent
    })
  }
  return Cobrowsing
})()

export default Cobrowsing



// WEBPACK FOOTER //
// ./src/components/watcheebox/cobrowsing.js